/*
Use a type-guard [1] to refine the type of the input. This is useful especially when dealing
with `Maybe<T>` types from GraphQL

[1] https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
*/
export function notEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
